<template>
  <div
    class="test-method-matrix px-8 py-10 container"
    style="max-width: 1150px; margin: 0 auto;"
  >
    <div class="flex flex-wrap">
      <div class="w-full">
        <TitleComponent class="py-8" title="SSEC Method 1" size="large" />

        <p class="text-2xl font-bold text-center -mt-6">
          Limited Operations – “Unpackaged”
        </p>

        <p class="text-lg text-center mt-1" style="color:#7e8890;">
          Other Unpackaged Explosives
        </p>

        <p class="text-xl font-bold mt-8">
          PAGE UNDER CONSTRUCTION
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import TitleComponent from "@/components/TitleComponent";

export default {
  components: {
    TitleComponent
  }
};
</script>

<style lang="scss"></style>
